// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimLookupModel {
    static getAttributeTypeMap() {
        return ClaimLookupModel.attributeTypeMap;
    }
}
ClaimLookupModel.discriminator = undefined;
ClaimLookupModel.additionalProperties = false;
ClaimLookupModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
];
//# sourceMappingURL=claimLookupModel.js.map